import Vue from 'vue'
import i18n from '../../helpers/i18nHelpers'
import store from '../store'
import axios from 'axios'

const vueObj = new Vue()

const state = {
  isFetching: false,
  isCanceling: false,
  isCancelingReviseDateTime: false,
  isCancelingAdditionalHours: false,
  isConfirmingReviseDateTime: false,
  isSavingAdditionalHours: false,
  isUpdating: false,
  isFindingNewCleaner: false,
  order: null,
  hasReviseDateTime: false,
  reviseDateTime: null,
  cancelCondition: null,
  hasCancelError: false,
  tmpAdditionalHoursBookingData: null,
  tmpPurchaseServiceData: null,
  tmpProfessionalTipData: null
}

const actions = {
  loadOrderDetail: async ({commit}, id) => {
    commit('REQUEST_ORDER_DETAIL')
    const url = `orders/${id}`
    const res = await axios.get(url)
    if (res.status === 200) {
      const response = res.data
      if (!response.error) {
        commit('SET_ORDER_DETAIL', response)
      }
    }
  },
  LOAD_CANCEL_CONDITION: ({commit}, id) => {
    commit('SET_CANCEL_CONDITION', null)
    Vue.http.get('orders/' + id + '/cancel-condition')
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          commit('SET_CANCEL_CONDITION', response.cancel_condition)
        }
      })
  },
  CANCEL_ORDER: ({commit}, submitData) => {
    commit('SET_CANCEL_ORDER', true)
    commit('SET_HAS_CANCEL_ERROR', false)
    Vue.http.delete('orders', {body: submitData})
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_CANCEL_ORDER', false)
        if (response.error) {
          commit('SET_HAS_CANCEL_ERROR', true)
          const alertText = 'Error: ' + response.message
          vueObj.$swal({
            text: alertText,
            type: 'error'
          }).then(() => {
            store.dispatch('orderDetail/loadOrderDetail', submitData.order_id)
          })
        }
      })
  },
  ADD_REVISE_DATE_TIME: ({commit}, submitData) => {
    commit('SET_UPDATE_DATA', true)
    const url = 'orders/' + submitData.order_id + '/add-revise-datetime'
    Vue.http.post(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        console.log('revise date-time', response)
        commit('SET_UPDATE_DATA', false)
        if (!response.error) {
          commit('SET_REVISE_DATE_TIME', response.revise_datetime_data)
        } else {
          let alertMsg = null
          switch (response.error_case) {
            case 'SELECT_SAME_DATETIME':
              alertMsg = i18n.t('message.alert.select_same_datetime')
              break
            case 'CLEANER_CHECKED_IN':
              alertMsg = i18n.t('message.alert.cleaner_checked_in')
              break
            case 'CLEANER_NOT_AVAILABLE':
              alertMsg = i18n.t('message.alert.cleaner_not_available')
              break
          }
          alert(alertMsg)
        }
      })
  },
  CONFIRM_REVISE_DATE_TIME: ({commit}, submitData) => {
    commit('SET_CONFIRMING_REVISE_DATE_TIME', true)
    const url = 'orders/' + submitData.order_id + '/confirm-revise-datetime'
    Vue.http.post(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_CONFIRMING_REVISE_DATE_TIME', false)
        commit('SET_REVISE_DATE_TIME', null)
        commit('SET_CLEANING_DATE_TIME', response.cleaning_date)
      })
  },
  CANCEL_REVISE_DATE_TIME: ({commit}, submitData) => {
    commit('SET_CANCEL_REVISE_DATE_TIME')
    const url = 'orders/' + submitData.order_id + '/cancel-revise-datetime'
    Vue.http.post(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('FINISH_CANCEL_REVISE_DATE_TIME')
        if (!response.error) {
          commit('SET_REVISE_DATE_TIME', null)
        }
      })
  },
  FIND_NEW_CLEANER: async ({commit}, submitData) => {
    commit('SET_FIND_NEW_CLEANER', true)
    const url = `orders/${submitData.order_id}/find-new-cleaner`
    const { data } = await axios.post(url, submitData)
    if (!data.error) {
      commit('SET_FIND_NEW_CLEANER', false)
    }
  },
  ADD_CREDIT_CARD_PAYMENT: ({commit}, submitData) => {
    commit('SET_UPDATE_DATA', true)
    const url = 'orders/' + submitData.order_id + '/credit-card-payment'
    Vue.http.post(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_UPDATE_DATA', false)
        if (!response.error) {
          console.log('Success')
        }
      })
  },
  CONFIRM_CREDIT_CARD_LIMIT: ({commit}, orderId) => {
    const url = 'orders/' + orderId + '/confirm-credit-card-limit'
    Vue.http.post(url)
      .then(response => {
        return response.json()
      })
      .then(response => {
        console.log(response)
        store.dispatch('orderDetail/loadOrderDetail', orderId)
      })
  }
}

const mutations = {
  REQUEST_ORDER_DETAIL: (state) => {
    state.isFetching = true
  },
  SET_CANCEL_ORDER: (state, status) => {
    state.isCanceling = status
  },
  SET_HAS_CANCEL_ERROR: (state, status) => {
    state.hasCancelError = status
  },
  SET_ORDER_DETAIL: (state, data) => {
    state.isFetching = false
    state.order = data
  },
  SET_UPDATE_DATA: (state, status) => {
    state.isUpdating = status
  },
  SET_REVISE_DATE_TIME: (state, data) => {
    state.order.revise_datetime_data = data
  },
  SET_CANCEL_REVISE_DATE_TIME: (state) => {
    state.isCancelingReviseDateTime = true
  },
  FINISH_CANCEL_REVISE_DATE_TIME: (state) => {
    state.isCancelingReviseDateTime = false
  },
  SET_ADDING_ADDITIONAL_HOURS: (state, status) => {
    state.isSavingAdditionalHours = status
  },
  SET_FIND_NEW_CLEANER: (state, status) => {
    state.isFindingNewCleaner = status
  },
  SET_CONFIRMING_REVISE_DATE_TIME: (state, status) => {
    state.isConfirmingReviseDateTime = status
  },
  SET_ORDER_REVISE_DATE_TIME: (state, data) => {
    state.order.revise_datetime_data = data
  },
  SET_CLEANING_DATE_TIME: (state, data) => {
    state.order.cleaning_date = data
  },
  SET_CANCEL_CONDITION: (state, data) => {
    state.cancelCondition = data
  },
  UPDATE_ORDER_DETAIL_DATA: (state, data) => {
    if (state.order) {
      state.order[data.key] = data.value
    }
  },
  SET_TMP_ADDITIONAL_HOURS_BOOKING_DATA: (state, data) => {
    state.tmpAdditionalHoursBookingData = data
  },
  SET_TMP_PURCHASE_SERVICE_DATA: (state, data) => {
    state.tmpPurchaseServiceData = data
  },
  SET_TMP_PROFESSIONAL_TIP_DATA: (state, data) => {
    state.tmpProfessionalTipData = data
  }
}

const getters = {
  getState: state => {
    return state
  },
  getOrderDetail: state => {
    return state.order
  },
  getIsFetching: state => {
    return state.isFetching
  },
  getIsCanceling: state => {
    return state.isCanceling ? 'message.button.canceling' : 'message.button.cancel_order'
  },
  getIsUpdating: state => {
    return state.isUpdating ? 'message.button.loading' : 'message.button.submit'
  },
  getIsUpdatingStatus: state => {
    return state.isUpdating
  },
  getIsCancelingReviseDateTime: state => {
    return state.isCancelingReviseDateTime ? 'message.button.canceling' : 'message.button.cancel'
  },
  getIsCancelingAdditionalHours: state => {
    return state.isCancelingAdditionalHours ? 'message.button.canceling' : 'message.button.cancel'
  },
  getIsConfirmReviseDateTime: state => {
    return state.isConfirmingReviseDateTime
  },
  getIsFindingNewCleaner: state => {
    return state.isFindingNewCleaner ? 'message.processing' : 'message.declined_booking.find_new_cleaner'
  },
  getIsFindingNewCleanerOrderDetail: state => {
    return state.isFindingNewCleaner ? 'message.processing' : 'message.button.find_new_cleaner'
  },
  getIsCancelAndRefund: state => {
    return state.isCanceling ? 'message.button.canceling' : 'message.declined_booking.cancel_and_refund'
  },
  getCancelCondition: state => {
    return state.cancelCondition
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/order.detail.js